import * as React from 'react';
import styles from '../../styles/image.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MIME_DICT = new Map([['apng', 'image/apng'], ['bmp', 'image/bmp'], ['gif', 'image/gif'], ['ico', 'image/ico'], ['cur', 'image/ico'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['png', 'image/png'], ['svg', 'image/svg'], ['webp', 'image/webp']]);
var getFileExt = function getFileExt(src) {
  var pathname = src.split(/[?#]/)[0];
  var resultArray = pathname.split(/\./);
  return resultArray[resultArray.length - 1];
};
var getMimeType = function getMimeType(src) {
  return MIME_DICT.get(getFileExt(src));
};
export var Component = function Component(_ref, ref) {
  var onLoad = _ref.onLoad,
    onError = _ref.onError,
    src = _ref.src,
    sources = _ref.sources,
    className = _ref.className,
    alt = _ref.alt,
    title = _ref.title,
    objectFit = _ref.objectFit,
    loading = _ref.loading;
  return /*#__PURE__*/_jsxs("picture", {
    className: className,
    children: [sources.map(function (_ref2) {
      var srcset = _ref2.srcset,
        media = _ref2.media,
        sizes = _ref2.sizes;
      return /*#__PURE__*/_jsx("source", {
        srcSet: srcset,
        media: media,
        sizes: sizes,
        type: getMimeType(srcset)
      }, srcset + (media || '') + (sizes || ''));
    }), /*#__PURE__*/_jsx("img", {
      className: styles['image'],
      alt: alt,
      title: title,
      decoding: 'async',
      style: {
        objectFit: objectFit
      },
      onLoad: onLoad,
      onError: onError,
      src: src,
      ref: ref,
      loading: loading
    })]
  });
};
Component.displayName = 'Picture';
export var Picture = /*#__PURE__*/React.forwardRef(Component);